import { BaseWebComponentRepository } from '../../framework/BaseWebComponentRepository';
import { DashboardAppDataProviderFactory } from '../factory/DashboardAppDataProviderFactory';
import { DashboardAppBaseDataProvider } from '../dataProvider/DashboardAppBaseDataProvider';
import { Dashboard, Dashboards } from '../../types';

export class DashboardAppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: DashboardAppDataProviderFactory;
  public dataProvider: DashboardAppBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new DashboardAppDataProviderFactory(),
    });
  }

  async createDashboard(): Promise<Dashboard | null> {
    return await this.dataProvider.createDashboard();
  }

  async initDashboards(): Promise<Dashboards> {
    return await this.dataProvider.initDashboards();
  }
}
